import React from "react"

export default function FieldStatus_InlineValueNotEmpty(props:any) {

    const option = props.option

    const renderType = _.get(props.configOptions, 'renderType', null)

    switch (renderType) {

        case 'ui5'      :
        case 'ui5-18'   :
        case 'ui5-22'   : {
            const classes = Classes('ui5-status-list', 'status-c{0}'.f(option.color), props.className, {
                's18': renderType === 'ui5-18',
                's22': renderType === 'ui5-22'
            })
            return (
                <React.Fragment>
                    <div className={classes} onClick={props.onClick}>
                        {option.label}
                    </div>
                    {props.children}
                </React.Fragment>
            )
        }

        default        :
            const classes = Classes("ui5-status selector s26", "status-c{0}".f(option.color), props.field.classes.inlineValueClass, props.className)

            return (
                <React.Fragment>
                    <div className={classes} onClick={props.onClick}>
                        <div className="txt-truncate">
                            {option.label}
                        </div>
                    </div>
                    {props.children}
                </React.Fragment>
            )
    }
}
